import { HttpClient } from '@angular/common/http';
import { Component, OnInit, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import {
  ConfirmDialogComponent,
  ToastComponent,
  confirmDialog,
  toast,
} from '@kinet-open-network/client/shared/ui';
import { PrimeNGConfig, Translation } from 'primeng/api';
import { filter, interval } from 'rxjs';
import * as primengLocale from '../assets/i18n/sk/primeng.json';

@Component({
  standalone: true,
  imports: [RouterModule, ToastComponent, ConfirmDialogComponent],
  selector: 'kon-root',
  template: `
    <router-outlet />
    <kon-toasts></kon-toasts>
    <kon-confirm-dialog> </kon-confirm-dialog>
  `,
})
export class AppComponent implements OnInit {
  private primengConfig = inject(PrimeNGConfig);
  private http = inject(HttpClient);
  private swUpdate = inject(SwUpdate);

  ngOnInit(): void {
    this.setPrimeNgLocale();
    this.addTableFilterMatchModes();
    this.setupSwUpdate();

    if (window.location.hostname.includes('kinet.sk')) {
      const newHostName = window.location.hostname.replace(
        'kinet.sk',
        'telcohub.sk',
      );
      this.showRedirectDialog(newHostName);
    }
  }

  setPrimeNgLocale() {
    this.primengConfig.setTranslation(primengLocale as Translation);
  }

  private setupSwUpdate() {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.versionUpdates
        .pipe(
          filter(
            (evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY',
          ),
        )
        .subscribe(() =>
          toast({
            summary: 'Je dostupná nová verzia aplikácie.',
            sticky: true,
            severity: 'info',
            closable: false,
            actions: [
              {
                label: 'Aktualizovať',
                command: (message) => {
                  document.location.reload();
                },
              },
            ],
          }),
        );
      interval(2 * 60000).subscribe(() => this.swUpdate.checkForUpdate());
    }
  }

  private addTableFilterMatchModes() {
    this.primengConfig.filterMatchModeOptions.date.push('present');
    this.primengConfig.filterMatchModeOptions.text.push('present');
    this.primengConfig.filterMatchModeOptions.numeric.push('present');
  }

  private showRedirectDialog(newHostName: string) {
    confirmDialog({
      header: 'Upozornenie na presun aplikácie',
      message: `Aplikácia Telcohub sa presúva na doménu <b>https://${newHostName}</b>. <br>
Všetky odkazy na starú doménu budú presmerované na novú. <br>
Prosím, aktualizujte si svoje záložky a odkazy.<br><br>
Pri prvom prístupe na novú doménu budete vyzvaní na prihlásenie.<br>
Pre prihlásenie použite rovnaké prihlasovacie údaje a 2FA aké ste používali na starej doméne.
`,
      severity: 'warning',
      acceptLabel: 'Prejsť na ' + newHostName,
      rejectLabel: 'Zostať na starej doméne',
      acceptIcon: 'pi pi-arrow-right pr-2',
      rejectIcon: 'pi pi-times pr-2',
      accept: () => {
        const newUrl = `https://${newHostName}${window.location.pathname}${window.location.search}`;
        window.location.href = newUrl;
      },
    });
  }
}
